<template>
  <div class="d-inline">
    <span class="pa-0 d-block theme--light v-size--default align-center">
      基本設定
      <v-spacer></v-spacer>
    </span>
    <div class="pt-2 px-1">
      <v-text-field
        class="mb-5"
        autofocus
        :rules="[presenceValidation, urlValidation]"
        :value="editingItemable.url"
        dense
        @input="updateEditingItemable($event, 'url')"
      >
        <template v-slot:label>
          <InputLabel label-name="URL" :required="true" />
        </template>
      </v-text-field>
      <v-textarea
        class="mb-5"
        rows="2"
        :rules="[presenceValidation]"
        :value="editingItemable.content"
        dense
        @input="updateEditingItemable($event, 'content')"
      >
        <template v-slot:label>
          <InputLabel label-name="テキスト" :required="true" />
        </template>
      </v-textarea>
      <v-text-field
        class="mb-5"
        :rules="[presenceValidation, colorCodeValidation(true)]"
        :value="editingItemable.fontColor"
        dense
        @input="updateEditingItemable($event, 'fontColor')"
      >
        <template v-slot:label>
          <InputLabel label-name="文字色" :required="true" />
        </template>
        <template v-slot:append-outer>
          <ColorPickerMenu
            :color-code="editingItemable.fontColor"
            @change-color-code="updateEditingItemable($event, 'fontColor')"
          />
        </template>
      </v-text-field>
      <v-text-field
        class="mb-5"
        :rules="[presenceValidation, colorCodeValidation(true)]"
        :value="editingItemable.backgroundColor"
        dense
        @input="updateEditingItemable($event, 'backgroundColor')"
      >
        <template v-slot:label>
          <InputLabel label-name="背景色" :required="true" />
        </template>
        <template v-slot:append-outer>
          <ColorPickerMenu
            :color-code="editingItemable.backgroundColor"
            @change-color-code="
              updateEditingItemable($event, 'backgroundColor')
            "
          />
        </template>
      </v-text-field>
      <v-text-field
        class="mb-5"
        type="number"
        dense
        :min="1"
        :rules="[presenceValidation]"
        :value="editingItemable.fontSize"
        suffix="px"
        @input="updateEditingItemable(stringToNumber($event), 'fontSize')"
      >
        <template v-slot:label>
          <InputLabel label-name="文字サイズ" :required="true" />
        </template>
      </v-text-field>
      <span class="d-block caption v-label theme--light">アイコン</span>
      <div class="row justify-space-between">
        <div class="col-xl-4 col-12">
          <span class="d-block caption v-label theme--light">配置</span>
          <v-switch
            dense
            light
            label="縦並び"
            :input-value="editingItemable.flexColumn"
            @change="updateEditingItemable($event, 'flexColumn')"
          ></v-switch>
        </div>
        <div class="col-xl-4 col-6">
          <span class="d-block caption v-label theme--light">{{
            IconLabel.before
          }}</span>
          <SelectIconDialog
            v-if="!editingItemable.beforeIcon"
            @select-icon="updateEditingItemable($event, 'beforeIcon')"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mt-4" v-bind="attrs" v-on="on"> 設定する </v-btn>
            </template>
          </SelectIconDialog>
          <div v-else class="d-flex justify-space-between mt-4">
            <span>設定中</span>
            <v-btn
              color="danger"
              outlined
              small
              @click="updateEditingItemable('', 'beforeIcon')"
              >解除する</v-btn
            >
          </div>
        </div>
        <div class="col-xl-4 col-6">
          <span class="d-block caption v-label theme--light">{{
            IconLabel.after
          }}</span>
          <SelectIconDialog
            v-if="!editingItemable.afterIcon"
            @select-icon="updateEditingItemable($event, 'afterIcon')"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mt-4" v-bind="attrs" v-on="on"> 設定する </v-btn>
            </template>
          </SelectIconDialog>
          <div v-else class="d-flex justify-space-between mt-4">
            <span>設定中</span>
            <v-btn
              color="danger"
              outlined
              small
              @click="updateEditingItemable('', 'afterIcon')"
              >解除する</v-btn
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'
import ButtonItemPreview from '../previews/ButtonItemPreview'
import ButtonItemFormPreview from './ButtonItemFormPreview'
import ColorPickerMenu from '@/components/commons/ColorPickerMenu'
import BaseForm from './BaseForm'
import SelectIconDialog from './SelectIconDialog'

export default {
  name: 'BaseForm',
  components: {
    SelectIconDialog,
    BaseForm,
    ColorPickerMenu,
    ButtonItemFormPreview,
    ButtonItemPreview,
    InputLabel
  },
  mixins: [itemUtilsMixin, formValidationUtils],
  computed: {
    IconLabel () {
      if (this.editingItemable.flexColumn) {
        return {
          before: '上側',
          after: '下側'
        }
      }
      return {
        before: '左側',
        after: '右側'
      }
    }
  },
  methods: {
    stringToNumber (stringValue) {
      if (!stringValue) return

      return Number(stringValue)
    }
  }
}
</script>
